import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';

const MajorViewOdds = ({
  oddsData,
  team,
  isTimeView,
  oddsOpenButtonRef,
  closeOdds
}) => {
  const oddsRef = useRef();
  const onClick = (event) => {
    if (oddsRef.current && !oddsRef.current.contains(event.target)) {
      if (
        oddsOpenButtonRef.current &&
        !oddsOpenButtonRef.current.contains(event.target)
      ) {
        closeOdds(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', onClick, true);
    return () => {
      document.removeEventListener('click', onClick, true);
    };
  }, []);

  return (
    <div
      className={clsx(style.layer_odds, isTimeView && style.timeView)}
      ref={oddsRef}
    >
      <div className={style.title}>배당안내</div>
      <table className={style.list} border="1">
        <caption>배당안내</caption>
        <colgroup>
          <col width="" />
          <col width="48px" />
          <col width="48px" />
        </colgroup>
        <thead>
          <tr>
            <th>팀명</th>
            <th>국내</th>
            <th>해외</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={style.name}>{team.away.name}</td>
            <td className={style.odds}>
              <span>{!!oddsData.domestic.away && oddsData.domestic.away}</span>
              <span>
                {!!oddsData.domestic.awayOption && oddsData.domestic.awayOption}
              </span>
            </td>
            <td className={style.odds}>
              <span>
                {!!oddsData.international.away && oddsData.international.away}
              </span>
              <span>
                {!!oddsData.international.awayOption &&
                  oddsData.international.awayOption}
              </span>
            </td>
          </tr>
          <tr>
            <td className={style.name}>{team.home.name}</td>
            <td className={style.odds}>
              <span> {!!oddsData.domestic.home && oddsData.domestic.home}</span>
              <span>
                {!!oddsData.domestic.homeOption && oddsData.domestic.homeOption}
              </span>
            </td>
            <td className={style.odds}>
              <span>
                {!!oddsData.international.home && oddsData.international.home}
              </span>
              <span>
                {!!oddsData.international.homeOption &&
                  oddsData.international.homeOption}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MajorViewOdds;
